(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const forms = document.querySelectorAll('.blog-post-featured-product-card__form');
    
    forms.forEach(function(form) {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const button = form.querySelector('.blog-post-featured-product-card__add-button');
        const originalContent = button.innerHTML;
        const variantId = form.querySelector('input[name="id"]').value;
        const quantity = form.querySelector('input[name="quantity"]').value || 1;
        const productId = form.closest('.blog-post-featured-product-card')?.querySelector('a')?.href?.match(/\/products\/([^\/]+)/)?.[1];
        
        // Disable button and show loading state
        button.disabled = true;
        button.style.opacity = '0.6';
        
        const formData = new FormData(form);
        
        // Get cart drawer section ID for sections update
        const cartDrawer = document.querySelector('cart-drawer-component');
        const cartItemsComponent = document.querySelector('cart-items-component');
        const sectionId = cartItemsComponent?.dataset?.sectionId;
        
        // Add sections parameter if available
        if (sectionId) {
          formData.append('sections', sectionId);
        }
        
        try {
          const cartAddUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
          
          // Use Accept: 'text/html' header to get sections back (matching product-form.js pattern)
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            body: formData,
            headers: {
              Accept: 'text/html',
            },
          });
          
          const data = await response.json();
          
          if (response.ok && !data.status) {
            // Dispatch CartAddEvent-like event that the cart drawer listens to
            // The event name should match ThemeEvents.cartUpdate which is 'cart:update'
            const cartAddEvent = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: variantId,
                data: {
                  source: 'blog-post-featured-products',
                  itemCount: Number(quantity),
                  productId: productId,
                  variantId: variantId,
                  sections: data.sections || {},
                },
              },
            });
            
            document.dispatchEvent(cartAddEvent);
            
            // Open cart drawer
            if (cartDrawer) {
              cartDrawer.open();
            }
            
            // Show success feedback
            button.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 8L6 11L13 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            button.style.opacity = '1';
            
            // Reset after 2 seconds
            setTimeout(function() {
              button.innerHTML = originalContent;
              button.disabled = false;
            }, 2000);
          } else {
            // Handle error response
            const errorMessage = data.message || data.description || 'Failed to add to cart';
            throw new Error(errorMessage);
          }
        } catch (error) {
          console.error('Add to cart error:', error);
          button.disabled = false;
          button.style.opacity = '1';
          // Show error message
          alert(error.message || 'Unable to add product to cart. Please try again.');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
